<template>
    <div class="loader" :style="style"></div>
</template>

<script>
export default {
    props: {
        backgroundColor: {
            type: String,
            required: false,
            default: '#f4f6f9'
        },
        loaderColor: {
            type: String,
            required: false,
            default: '#8C909C'
        },
        width: {
            type: Number,
            required: false,
            default: 16
        },
        height: {
            type: Number,
            required: false,
            default: 16
        },
        position: {
            type: String,
            required: false,
            default: 'absolute'
        }
    },
    data() {
        return {
            style: {
                border: `2px solid ${this.loaderColor}`,
                borderBottom: `2px solid ${this.backgroundColor}`,
                backgroundColor: this.backgroundColor,
                width: `${this.width}px`,
                height: `${this.height}px`,
                position: this.position
            }
        }
    }
}
</script>

<style scoped>
.loader {
  border-radius: 50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>